export default __webpack_public_path__ + "static/media/guide02@2x.f7f879e1.png";